/* istanbul ignore file */
import { Component, Input, OnInit } from '@angular/core';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-pending-test',
  templateUrl: './pending-test.component.html',
  styleUrls: ['./pending-test.component.scss']
})
export class PendingTestComponent implements OnInit{

  @Input() totalPendingTest: number;
  descriptionList: Array<string>;

  constructor(    
    private resourceService: ADPResourceService
  ) { }

  ngOnInit(): void {
    this.descriptionList = this.getResource('PendingPhones_Description')?.split(';');
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : "Dashboard";
    let title = namespace + "_" + name;
    let resourceValue = this.resourceService.getLabel(title);
    return resourceValue;
  }
}
